import { useEffect, useRef } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];

    const run = async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.location.href = "/dashboard";
      } catch (e) {
        const detail = e.response?.data?.detail;
        if (e.response?.status === 403 && typeof detail === "string") {
          sessionStorage.setItem("login_denied", detail);
        }
        window.location.href = "/login";
      }
    };
    if (sessionId) run();
    else window.location.href = "/login";
    // Runs once on mount to exchange the OAuth session_id
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <Loader2 className="h-8 w-8 animate-spin text-blue-700" />
      <p className="mt-4 text-slate-500 text-sm">Signing you in…</p>
    </div>
  );
}
